import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { DocumentService } from '@app/_services/masters/document.service';
import { document } from '@app/_models/document';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbModalConfig, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { LogService } from '../../../_shared/log.service'

@Component({
  selector: 'app-document-master-add',
  templateUrl: './document-master-add.component.html',
  styleUrls: ['./document-master-add.component.css']
})
export class DocumentMasterAddComponent implements OnInit {
  document = new document();

  constructor(private eventService: LogService, private formBuilder: FormBuilder, private documentService: DocumentService,
    private modalService: NgbModal, config: NgbModalConfig, private router: Router) { }

  documentForm: FormGroup;
  submitted = false;
  strMessage:string;
  getresponse: any;
  @ViewChild('showModalBox', { read: TemplateRef }) showModalBoxTemplate: TemplateRef<any>;
  returnUrl;

  ngOnInit(): void {
    this.documentForm = this.formBuilder.group({
      documentName: ['', Validators.required]
    });
  }
  get f() { return this.documentForm.controls; }

  addDocument() {
    this.submitted = true;

    if (this.documentForm.invalid) {
      return;
    }
    this.documentService.addDocument(this.document)
      .subscribe((response) => {
        if (response) {
          this.getresponse = response;
          if (this.getresponse.respMessage == "Success") {
            this.strMessage="Document Added Successfully.";
            this.modalService.open(this.showModalBoxTemplate);
            var v = response;
          }
          else   if (this.getresponse.respMessage == "Failure") {
            this.strMessage=this.getresponse.respData;
            this.modalService.open(this.showModalBoxTemplate);
            var v = response;
          }
        }
        
      },
        (err: any) => {
          var message = err;
        });
  }

  refresh(): void {
    this.modalService.dismissAll(this.showModalBoxTemplate);
    this.eventService.emit<string>('4');
  }
  goBack()
  {
    this.eventService.emit<string>('4');
  }

}
